import { useEffect, useState } from 'react';

export const SNAPSHOTS_URL = 'https://snapshots.kingnodes.com';

export interface SnapshotNetwork {
  slug: string;
  name: string;
}

// Served by src/worker.js from the snapshot site's public network list. Fetched once per page load.
let pending: Promise<SnapshotNetwork[]> | null = null;

function loadSnapshotNetworks(): Promise<SnapshotNetwork[]> {
  pending ??= fetch('/snapshot-networks.json')
    .then((res) => (res.ok ? res.json() : []))
    .catch(() => []);
  return pending;
}

/** Chains with a page on the snapshot site; empty until loaded, and if the list can't be fetched. */
export function useSnapshotNetworks(): SnapshotNetwork[] {
  const [networks, setNetworks] = useState<SnapshotNetwork[]>([]);
  useEffect(() => {
    let live = true;
    loadSnapshotNetworks().then((list) => {
      if (live) setNetworks(list);
    });
    return () => {
      live = false;
    };
  }, []);
  return networks;
}

// "XRPL EVM" and "xrplevm", or "XION" and "Xion", name the same chain.
const key = (name: string) => name.toLowerCase().replace(/[^a-z0-9]/g, '');

export function snapshotNetworkUrl(network: SnapshotNetwork): string {
  return `${SNAPSHOTS_URL}/network/${network.slug}`;
}

/** The snapshot page for a chain named as Hygraph names it, if the snapshot site has one. */
export function snapshotUrlFor(networks: SnapshotNetwork[], name: string): string | undefined {
  const k = key(name);
  const match = networks.find((n) => n.slug === k || key(n.name) === k);
  return match && snapshotNetworkUrl(match);
}
